export default "__VITE_ASSET__e2342f13__"